import { t } from '@lingui/core/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { NoddiInformationBox } from 'noddi-ui-web';
import { getRelevantInfo } from '../../utils/getInfoAboutBooking';

export const RelevantQuestionsForBooking = ({ booking }: { booking: BookingRecordDetailsCustomer }) => {
  const relevantInfo = getRelevantInfo({ booking });

  return (
    <div>
      <NoddiInformationBox title={t`Important info about your booking`}>
        <div className='flex flex-col gap-4'>
          {relevantInfo.map((item, index) => (
            <div key={index} className='flex gap-2'>
              <b>{index + 1}.</b>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </NoddiInformationBox>
    </div>
  );
};
